export default __webpack_public_path__ + "media/images/main/minus-96a3cd2575f76e57bab67b3f4f3cd50d.png";